// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { TranslateService } from '@ngx-translate/core';
import { ListApiResponseV2 } from 'src/app/shared/interfaces/_base/api-response.interface';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class PricesService {
  // serviceTypes: { label: string; value: string; price: number }[] = [
  //   {
  //     label: this.translateService.instant('services.types.new_digital_doc_first_file'),
  //     value: 'new_digital_doc_first_file',
  //     price: 10,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.new_digital_doc_other_file'),
  //     value: 'new_digital_doc_other_file',
  //     price: 3
  //   },
  //   {
  //     label: this.translateService.instant('services.types.new_paper_doc_first_file'),
  //     value: 'new_paper_doc_first_file',
  //     price: 7,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.new_paper_doc_other_file'),
  //     value: 'new_paper_doc_other_file',
  //     price: 2,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.scan_a4'),
  //     value: 'scan_a4',
  //     price: 0.4,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.scan_a3'),
  //     value: 'scan_a3',
  //     price: 0.5,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.scan_a2'),
  //     value: 'scan_a2',
  //     price: 3,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.scan_a1'),
  //     value: 'scan_a1',
  //     price: 5.5,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.scan_a0'),
  //     value: 'scan_a0',
  //     price: 7,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.scan_no_format'),
  //     value: 'scan_no_format',
  //     price: 0,
  //   },
  //   {
  //     label: this.translateService.instant('services.types.box'),
  //     value: 'box',
  //     price: 4
  //   },
  // ];

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService,
    private translateService: TranslateService,
  ) { }

  /**
   * Create a new price
   *
   * @since 1.0.0
   *
   * @param price Price data
   * @returns Observable<any>
   */
  create(price: any): Observable<any> {
    return this.apiService.apiCall('POST', 'prices', price);
  }

  /**
   * Get prices list for given query params
   *
   * @since 1.0.0
   *
   * @param [start] Query left offset
   * @param [limit] Results number
   * @param [sort] Sorting field name
   * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
   * @param [search] Filtering object with fildering data string
   */
  getList(start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<ListApiResponseV2> {
    const params: any = { start, limit, sort, sortVersus };
    if (search) {
      Object.keys(search).forEach(key => {
        const newParamKey = `search[${key}]`;
        const newParamValue = search[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService.apiCall('GET', 'prices', params);
  }

  /**
   * Get an exportation file of all prices
   *
   * @since 1.0.0
   */
  getExport(): Observable<any> {
    return this.apiService.apiCall('GET', 'prices/export', {}, { responseType: 'blob' })
      .pipe(
        catchError(err => {
          return this.helperService.parseErrorBlob(err);
        })
      );
  }

  /**
   * Get given priceId data from back-end
   *
   * @since 1.0.0
   *
   * @param priceId ID of the price to get
   */
  get(priceId: string): Observable<any> {
    return this.apiService.apiCall('GET', `prices/${priceId}`).pipe(
      catchError(err => {
        this.helperService.handleError(err);
        return throwError(err);
      })
    );
  }

  /**
   * Update price with given priceId with given price data
   *
   * @since 1.0.0
   *
   * @param priceId ID of price to update
   * @param data New price's data
   */
  update(priceId: string, data: object): Observable<any> {
    return this.apiService.apiCall('PUT', `prices/${priceId}`, data);
  }

  /**
   * Delete permanently a price
   *
   * @since 1.0.0
   *
   * @param priceId ID of the price
   */
  delete(priceId: string): Observable<any> {
    return this.apiService.apiCall('DELETE', `prices/${priceId}`);
  }
}
